import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div className="content-page-container">
      <div className="content-page-card">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: December 1, 2025</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to TollyHype ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal information. 
            This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website and participate in our movie voting platform.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect information you provide directly to us, including:</p>
          <ul>
            <li><strong>Account Information:</strong> Name, email address, and password when you register.</li>
            <li><strong>Profile Data:</strong> Profile color preferences and voting history.</li>
            <li><strong>Usage Data:</strong> Information about how you use our website, including your votes, streaks, and interactions with our leaderboard and chat.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected data to:</p>
          <ul>
            <li>Provide, maintain, and improve our services.</li>
            <li>Manage your account and track your voting progress and streaks.</li>
            <li>Display your username on public leaderboards and chat (if you participate).</li>
            <li>Communicate with you about updates or changes to our services.</li>
            <li>Prevent fraud and ensure the integrity of our voting system.</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Sharing and Disclosure</h2>
          <p>
            We do not sell your personal data. We may share your information in the following limited circumstances:
          </p>
          <ul>
            <li><strong>Publicly:</strong> Your username and voting statistics may be displayed on leaderboards and in chat rooms.</li>
            <li><strong>Service Providers:</strong> With vendors who help us operate our website (e.g., hosting, database management).</li>
            <li><strong>Legal Requirements:</strong> If required by law or to protect our rights.</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement reasonable security measures to protect your information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>
            You have the right to access, update, or delete your personal information. You can manage most of your data directly through your profile settings.
          </p>
        </section>

        <section>
          <h2>7. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:support@tollyhype.com">support@tollyhype.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}

